import { render, staticRenderFns } from "./StageButton.vue?vue&type=template&id=2519bcf8&"
import script from "./StageButton.vue?vue&type=script&lang=js&"
export * from "./StageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports